module.exports = __webpack_public_path__ + "static/media/choose-image.19e9dd68.svg";